import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 570px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;
  position: relative;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-radius: 50%;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }

  svg {
    width: 20px;
    height: 20px;
    color: #6c757d;
  }
`;

export const ModalHeader = styled.div`
  padding: 24px 32px 16px;
  border-bottom: 1px solid #dee2e6;
`;

export const ModalTitle = styled.h2`
  font-family: "Nunito", sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #2c5697;
  margin: 0;
  text-align: center;
`;

export const ModalBody = styled.div`
  padding: 28px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;

  .icon-container {
    width: 64px;
    height: 64px;
    position: relative;
    overflow: hidden;

    @media (max-width: 768px) {
      width: 26px;
      height: 26px;
    }
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 64px;
    height: 64px;

    @media (max-width: 768px) {
      width: 26px;
      height: 26px;
    }
  }
`;

export const ModalMessage = styled.p`
  font-family: "Nunito", sans-serif;
  font-size: 18px;
  font-weight: 400;
  color: #475061;
  margin: 0;
  line-height: 24px;
  word-wrap: break-word;
  text-align: center;
`;

export const ModalDetails = styled.div`
  width: 100%;
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin-top: 16px;
`;

export const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;

  &:not(:last-child) {
    border-bottom: 1px solid #dee2e6;
  }
`;

export const DetailLabel = styled.span`
  font-family: "Nunito", sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #495057;
`;

export const DetailValue = styled.span`
  font-family: "Nunito", sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #212529;
  text-align: right;
`;

export const ModalActions = styled.div`
  align-self: stretch;
  padding: 16px 32px;
  border-top: 1px solid #d4d7d9;
  justify-content: center;
  align-items: center;
  gap: 24px;
  display: inline-flex;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const ModalButton = styled.button`
  width: 200px;
  padding: 8px 24px;
  border-radius: 48px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  display: flex;
  font-family: "Nunito", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  word-wrap: break-word;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;

  ${(props) =>
    props.variant === "primary"
      ? `
    background: #0BBEF0;
    color: white;

    &:hover {
      background: #09a8d4;
    }
  `
      : `
    background: white;
    outline: 2px #0BBEF0 solid;
    outline-offset: -2px;
    color: #0BBEF0;

    &:hover {
      background: #f8f9fa;
    }
  `}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
